import React, { Component } from "react";
class SendToCMS extends Component {
  constructor(props) {
    super(props);
    this.state = {
      company: "all",
      qid: null,
    };
  }
  handleSelectChange = e => {
    this.setState({
      company: e.currentTarget.value,
    });
  };

  sendToCMS = e => {
    const { id, ctime, qid } = this.props;
    const { company } = this.state;
    if (company === "") {
      alert("Pick a company!!");
      return;
    }
    window.open(
      `https://dowhatworks.io/admin/screenshots/new?id=${id}&ctime=${ctime}&company=${company}&qid=${qid}`
    );
  };
  render() {
    return (
      <>
        <select onChange={this.handleSelectChange} value={this.state.company}>
          <option name="company" value="all">
            All Tests
          </option>
          <option name="company" value="test">
            Testing
          </option>
        </select>
        <button style={{ marginLeft: "6px" }} onClick={this.sendToCMS}>
          Send to CMS
        </button>
      </>
    );
  }
}

export default SendToCMS;
